import {
	SimpleGrid, Stack, Text,
} from '@chakra-ui/react';
import React from 'react';

import { images } from '@/constants/images';
import { SpecialFeatureCard } from '@/modules/job';

const mockedFeature = {
	image: images.mocked.featured,
	title: 'Remote Work',
};

export const FeaturedJobsScreen = () => {
	return (
		<Stack gap="lg">
			<Text textAlign="center" textStyle="h1">
				Special Feature
			</Text>
			<SimpleGrid columns={3} gap="md">
				{Array.from({ length: 12 }).map((_, index) => (
					<SpecialFeatureCard key={`special-feature-${index}`} {...mockedFeature} />
				))}
			</SimpleGrid>
		</Stack>
	);
};
